export default {
  additionalServices: 'Additional services',
  capacity: 'Capacity',
  equipment: 'Equipment',
  equipmentAndServices: 'Equipment and services',
  focusAnimals: 'Focus on pets',
  info: 'Informations',
  roomsCount: 'Room count',
  roomsTypes: 'Room types',
  service: 'Service | Services',
  serviceName: 'Service name',
  slug: 'Short and exact service name (without diacritics)',
  id: {
    1: 'Accommodation',
    2: 'Ambulance',
    3: 'Salon',
    4: 'Training',
    5: 'Walking',
    6: 'Shelter'
  },
  type: {
    ambulance: 'Ambulance',
    hotel: 'Accommodation',
    salon: 'Salon',
    trainer: 'Training',
    walking: 'Walking',
    shelter: 'Shelter'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en/service.js